import uuid from 'uuid/v4';

import config from 'src/config';
import storageLib from 'lib/storage';

export default {
  setAuthToken(token) {
    if (!token) throw new Error('token is required');

    storageLib.setItem(config.AUTH_TOKEN, token, {
      expires: 7
    });
  },
  setProspectToken(token) {
    if (!token) throw new Error('token is required');

    storageLib.setItem(config.PROSPECT_TOKEN, token, {
      expires: 7
    });
  },
  getAuthToken() {
    return storageLib.getItem(config.AUTH_TOKEN);
  },
  getProspectToken() {
    let prospectToken = storageLib.getItem(config.PROSPECT_TOKEN);

    if (!prospectToken) {
      prospectToken = uuid();

      storageLib.setItem(config.PROSPECT_TOKEN, prospectToken);
    }

    return prospectToken;
  },
  removeAuthToken() {
    storageLib.removeItem(config.AUTH_TOKEN);
  }
};



// WEBPACK FOOTER //
// ./src/api/auth/helper.js